import {Emitter} from "./emitter";

export class BundleQuantitySelector extends Emitter{
    constructor(selector, size) {
        super();
        this.selector = selector;
        this.input = selector.find('input[type="number"]');
        this.size = size;
        this.handleStepButtonClick = this.handleStepButtonClick.bind(this);
        selector.on('click', '.step-button', this.handleStepButtonClick);

    }

    handleStepButtonClick(e) {
        const
            {selector, input, size } = this,
            downButton = selector.find('.step-button.down'),
            button = $(e.target),
            delta = button.hasClass('up') ? 1 : -1,
            newValue = Math.max(0, parseInt(input.val(), 10) + delta);
            input.val(newValue);
        downButton.prop('disabled', newValue === 0);
        this.emit('change', newValue);
    }

    setValue(value) {
        value = Math.max(1, value);
        this.input.val(value);
        return this;
    }
}